import { useState } from "react";
import DotLoader from "react-spinners/DotLoader";
import { white } from "tailwindcss/colors";

const override = {
    display: "flex",
    margin: "0 auto",
    padding: "5px"
};

export function Spinner({ isSpinner, colorSpinner, textSpinner, sizeSpinner }) {

    let [loading, setLoading] = useState(isSpinner);
    let [color, setColor] = useState(colorSpinner);
    let [text, setTextSpinner] = useState(textSpinner);
    let [size, setSize] = useState(sizeSpinner);

    return (
        <>
            <div className="sweet-loading">
                <DotLoader color={color} loading={loading} cssOverride={override} size={size ?? 150} />
                <p className="mt-5 pt-5">
                {text}
            </p>

            </div>   
        </>

    );

}

